var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveIcon = function SvgActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H13L20 4V20H7L0 16V0Z",
    fill: "#A3E0B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2286 7.65535L8.97859 12.9053C8.78333 13.1006 8.46675 13.1006 8.27148 12.9053L5.77148 10.4053L6.47859 9.69824L8.62504 11.8447L13.5215 6.94824L14.2286 7.65535Z",
    fill: "#138634"
  })));
};
export { SvgActiveIcon as ReactComponent };
export default __webpack_public_path__ + "assets/2841cf4e.svg";